import React from 'react';
interface SlideProps {
  icon: React.ReactNode;
  title: string;
  content: React.ReactNode;
}
export function Slide({
  icon,
  title,
  content
}: SlideProps) {
  return <div className="bg-white rounded-xl shadow-sm p-6 w-full aspect-[16/9] transition-all animate-fadeIn border border-gray-100 relative overflow-y-auto" data-id="element-202">
      <div className="flex items-center mb-4" data-id="element-203">
        <div className="p-2 bg-gray-50 rounded-xl mr-4" data-id="element-204">{icon}</div>
        <h2 className="text-2xl md:text-3xl font-bold text-brand-purple" data-id="element-205">
          {title}
        </h2>
      </div>
      <div className="prose max-w-none" data-id="element-206">{content}</div>
    </div>;
}